import { API_URL, AUTH_URL } from "../constants";
import { HTTPClient, APIRequest, RequestType } from "../services/http_client";
import LocalStorageService from "../services/localstorage.service";
import { Note, SubmitableNote } from "../types/notes";
import { AUTH_KEY } from "../context/authContext";

export interface NoteFilters {
    createdAt?: string | null;
    keywords?: string;
    categoryId?: number;
    published?: number;
    limit?: number;
    page?: number;
}

interface NewsResponse {
  news: Array<Note>;
  total: number;
}

interface RawResponse {
  success: boolean;
  error: any;
}

const client = new HTTPClient()

const encodeFilters = (filters: NoteFilters) => {
  const encodedFilters = new URLSearchParams()

  Object.keys(filters).forEach((filter: any) => {
    const filterKey = filter as keyof NoteFilters;
    if(filters[filterKey] !== undefined && filters[filterKey] !== null){
      encodedFilters.append(filter, filters[filterKey]?.toString() ?? '')
    }
  })

  return encodedFilters.toString()
}

class Notes {
    static async getAll(props : NoteFilters){
        const request = new APIRequest(
            RequestType.GET,
            `${API_URL}/news?${encodeFilters(props)}`,
        )

        const response = await client.get(request)

        if (!response.success) {
            return {
                error: response.errorMessage,
                data: {},
            }
        }

        const data = response.result as unknown as NewsResponse

        return {
            error: undefined,
            data
        }
    }

    static async notify(noteId: number) {
      const auth = LocalStorageService.get(AUTH_KEY)
      if(!auth) return {
        error: "Unauthorized"
      }

      const request = new APIRequest(
        RequestType.POST,
        `${AUTH_URL}/news/notify/${noteId}`,
        undefined,
        auth.accessToken
      )

      const response = await client.post(request)

      if (!response.success) {
          return {
              error: response.errorMessage,
              data: {},
          }
      }

      return response.result as unknown as RawResponse
    }

    static async create(note: SubmitableNote) {
      const auth = LocalStorageService.get(AUTH_KEY)
      if(!auth) return {
        error: "Unauthorized"
      }

      const request = new APIRequest(
        RequestType.POST,
        `${AUTH_URL}/news`,
        JSON.stringify(note),
        auth.accessToken
      )

      const response = await client.post(request)

      if (!response.success) {
          return {
              error: response.errorMessage,
              data: {},
          }
      }

      return response.result as unknown as RawResponse
    }

    static async update(note: SubmitableNote) {
      const auth = LocalStorageService.get(AUTH_KEY)
      if(!auth) return {
        error: "Unauthorized"
      }

      const request = new APIRequest(
        RequestType.PUT,
        `${AUTH_URL}/news/${note.id}`,
        JSON.stringify(note),
        auth.accessToken
      )

      const response = await client.put(request)

      if (!response.success) {
          return {
              error: response.errorMessage,
              data: {},
          }
      }

      return response.result as unknown as RawResponse
    }

    static async findNote(noteId: number) {
      const request = new APIRequest(
        RequestType.GET,
        `${API_URL}/news/find/${noteId}`,
      )

      const response = await client.get(request)

      if (!response.success) {
          return {
              error: response.errorMessage,
              data: {},
          }
      }

      const data = response.result as unknown as NewsResponse

      return {
          error: undefined,
          data
      }
    }

    static async delete(noteId: number){
      const auth = LocalStorageService.get(AUTH_KEY)
      if(!auth) return {
        error: "Unauthorized"
      }

      const request = new APIRequest(
        RequestType.DELETE,
        `${AUTH_URL}/news/${noteId}`,
        undefined,
        auth.accessToken
      )

      const response = await client.delete(request)

      if (!response.success) {
          return {
              error: response.errorMessage,
              data: {},
          }
      }

      return response.result as unknown as RawResponse
    }
}

export default Notes